import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter, SimpleChanges, OnChanges, OnInit, Optional, Host, ChangeDetectorRef, AfterViewInit, effect } from '@angular/core';
import { SharedLayoutContentWrapperComponent } from '../content-wrapper/content-wrapper.component';

export class SidePanelService {
}

@Component({
  selector: 'app-side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SharedLayoutSidePanelComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() sidePanelClass = '';
  @Input() contentClass = '';

  @Input() collapsible = false;

  @Input() collapsed = false;
  @Output() collapsedChange = new EventEmitter<boolean>();

  _collapsed = true;

  constructor(@Optional() @Host() protected contentWrapper: SharedLayoutContentWrapperComponent) { 
    effect(() => this.tryApplySidePanelCollapsedToContentWrapper());
  }

  ngOnInit() {
    this._collapsed = this.collapsed;
    this.tryApplySidePanelCollapsedToContentWrapper();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.collapsed) {
      this._collapsed = changes.collapsed.currentValue;
      this.tryApplySidePanelCollapsedToContentWrapper();
    }
  }

  ngAfterViewInit() {
    this.tryApplySidePanelCollapsedToContentWrapper();
  }

  toggle(on?: boolean) {
    if (on === undefined)
      on = this._collapsed ? true : false;

    let collapsed = !on;

    if (collapsed === this._collapsed)
      return;

    this._collapsed = collapsed;

    this.tryApplySidePanelCollapsedToContentWrapper();

    this.collapsedChange.emit(this._collapsed);
  }

  private tryApplySidePanelCollapsedToContentWrapper() {
    let el = <Element>this.contentWrapper?.contentWrapperRef()?.nativeElement;
    if (el) {
      el.classList.toggle('side-panel-collapsed', this._collapsed);
    }
  }
}
